import { render } from "./SellerTermsConditions.vue?vue&type=template&id=22e3883a&scoped=true&ts=true"
import script from "./SellerTermsConditions.vue?vue&type=script&lang=ts"
export * from "./SellerTermsConditions.vue?vue&type=script&lang=ts"

import "./SellerTermsConditions.vue?vue&type=style&index=0&id=22e3883a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e3883a"]])

export default __exports__